import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { connect } from 'react-redux';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import NoTransaction from '../NoTransaction';
import CommonTable from '../../CommonTable/CommonTable';
import CurrencyConverter from '../../CurrencyConverter';
import Payouts from '../Payouts';
import Link from '../../Link';
// Locale
import messages from '../../../locale/jsonMessages';
import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import { dateFormat } from '../../../config';
import { formatLocalizedDate } from '../../../helpers/formatLocateDate';

import cs from '../../commonStyle.css';
import s from '../Transaction.css';

class FutureTransactions extends Component {
  static propTypes = {
    formatMessage: PropTypes.any,
    data: PropTypes.arrayOf(PropTypes.shape({
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      payoutId: PropTypes.number,
      listData: PropTypes.shape({
        title: PropTypes.string.isRequired
      }),
      guestData: PropTypes.shape({
        firstName: PropTypes.string.isRequired
      })
    }))
  };

  static defaultProps = {
    data: []
  };

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.transferDate) },
      { data: formatMessage(messages.transferType) },
      { data: formatMessage(messages.details) },
      { data: formatMessage(messages.payTo) },
      { data: formatMessage(messages.transferAmount) },
    ]
  };

  tbody = (props) => {
    const { data, locale } = props;
    return data.map((item, index) => {
      let date = item.checkIn ? moment(parseInt(item.checkOut)).add(1, 'days').format(dateFormat?.usDateFormat) : 'Pending';
      let checkInDate = item.checkIn ? formatLocalizedDate(item.checkIn, locale, dateFormat?.mediumDateFormat) : '';
      let checkOutDate = item.checkOut ? formatLocalizedDate(item.checkOut, locale, dateFormat?.mediumDateFormat) : '';
      let totalAmount = item.promoCodeType === 'admin' && Number(item.promoDiscount)
        ? (Number(item.total) + Number(item.promoDiscount)) - Number(item.hostServiceFee)
        : Number(item.total) - Number(item.hostServiceFee);
      let convertCurrency = item.currency;
      let payoutAmount = item?.cancellationDetails;
      if (payoutAmount) {
        totalAmount = item?.cancellationDetails?.payoutToHost || 0;
        convertCurrency = item?.cancellationDetails?.currency;
      }
      let dynamicTitle = JSON.parse(item?.dynamicListTitle);

      dynamicTitle = getDynamicTitle({ data: dynamicTitle, locale, id: item?.listId });


      return {
        id: index,
        data: [
          {
            data: date
          },
          {
            data: <FormattedMessage {...messages.reservation} />
          },
          {
            data: <ul className={cx(s.listLayout, 'listLayoutRTL')}>
              <li>
                <span className={cx(cs.fontWeightBold)}>{item.guestData ? item.guestData.firstName : ''}</span>
              </li>
              <li>
                <a href={'/cars/' + item.listId} target={"_blank"} className={cx(s.confirmCodeColor)}>{dynamicTitle ? dynamicTitle : (item.listTitle ? item.listTitle : (item.listData ? item.listData.title : ""))}</a>
              </li>
              <li>{checkInDate} - {checkOutDate}</li>
              <li>
                {item.listData && <Link to={"/users/trips/receipt/" + item.id} className={cx(s.confirmCodeColor)}>{item.confirmationCode}</Link>}
              </li>
              <li>{!item.listData && <span className={cx(s.confirmCodeColor)}>{item.confirmationCode}</span>}</li>
            </ul>
          },
          {
            data: <Payouts
              reservationId={item.id}
              type={"change"}
              enableAddPayout
              defaultValue={item.payoutId}
            />
          },
          {
            data: <CurrencyConverter
              amount={totalAmount}
              from={convertCurrency}
              className={s.currencyColor}
            />
          },
        ]
      }
    })
  }

  render() {
    const { data } = this.props;
    return (
      <div>
        {data.length > 0 &&
          <CommonTable
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            className={'payoutListTable'}
          />
        }
        {
          data.length === 0 && <div className={s.noTransactionSecSpace}>
            <NoTransaction className={s.noDataIconSec} />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({
  locale: state?.intl?.locale
})
const mapDispatch = {

}

export default injectIntl(
  connect(mapState, mapDispatch)(
    withStyles(s)(FutureTransactions)
  )
);

